import Tariff from './tariff';

export default class TariffsBundle {
    Id: number = 0;
    Name: string = '';
    Tariffs: Array<Tariff> = [];
}